import { Box } from '@mui/material';

interface TreeConnectorBoxProps {
  isLast: boolean;
  children: React.ReactNode;
}

export function TreeConnectorBox({ isLast, children }: TreeConnectorBoxProps) {
  return (
    <Box
      data-testid="tree-connector-box"
      sx={{
        display: 'flex',
        position: 'relative',
        minHeight: theme => theme.spacing(5),
      }}
    >
      {/* Vertical line + horizontal branch */}
      <Box
        sx={{
          width: theme => theme.spacing(2.5),
          flexShrink: 0,
          position: 'relative',
          // Vertical line: runs full height for non-last items, half for last
          '&::before': {
            content: '""',
            position: 'absolute',
            left: 0,
            top: 0,
            bottom: isLast ? '50%' : 0,
            width: 0,
            borderLeft: '1px solid',
            borderColor: 'divider',
          },
          // Horizontal branch: runs from vertical line to content
          '&::after': {
            content: '""',
            position: 'absolute',
            left: 0,
            top: '50%',
            width: theme => theme.spacing(1.75),
            height: 0,
            borderBottom: '1px solid',
            borderColor: 'divider',
          },
        }}
      />
      <Box sx={{ flex: 1, minWidth: 0 }}>{children}</Box>
    </Box>
  );
}
